import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useResetPw */
export type TypeResetPwParams = {
  /** 로그인 아이디 */
  username: string;
  /** 휴대전화 번호 */
  phoneNumber: string;
  /** 변경할 패스워드 */
  newPassword: string;
  /** 인증 코드 */
  verificationCode: string;
};

/** @category useResetPw */
export type TypeResetPwResponse = {
  /** 응답 메시지 */
  message: string;
};

/**
 * @description 비밀번호 초기화 api 요청에 사용되는 커스텀 훅
 */
export const useResetPw = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeResetPwParams) => {
      const endpoint = '/labor-accounts/modify-password';
      return axiosInstance.post(endpoint, params, { headers: { withoutToken: true } });
    },
  });

  const requestResetPw = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeResetPwParams;
    onSuccess?: (res: TypeResetPwResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestResetPw;
};
